// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-button {
  margin-top: 15px;
  margin-left: 20px;
}

.filter-caption {
  background-color: #ececec;
  border-radius: 20px !important;
  padding: 0px 10px 0px 10px !important;
  margin: 5px 0.5em 0em 5px !important;
  display: inline-block !important;
}

.performance-filter-height {
  height: auto;
  padding: 1em;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
